import React from 'react';
import { useLocation } from 'react-router-dom';
import Seo from './Seo';
import { CORE_PAGES, NOINDEX_PATH_PREFIXES, SITE_NAME } from './siteMeta';
import {
  organizationJsonLd,
  webSiteJsonLd,
  privateTransferPageJsonLd,
} from './jsonld';

// Mounted once inside the Router. Landing pages (Home, BusTickets, etc.) own
// their own <Seo> and this renders nothing for those routes — react-helmet-
// async is last-render-wins, so there's no conflict. This only fills in meta
// for core static pages that don't render their own Seo, and applies
// noindex to app/auth routes that shouldn't be crawled.
const CORE_PAGE_JSON_LD = {
  '/': () => [organizationJsonLd(), webSiteJsonLd()],
  '/private-transfer': () => privateTransferPageJsonLd(),
};

const PageMeta = () => {
  const { pathname } = useLocation();

  const corePage = CORE_PAGES.find((page) => page.path === pathname);
  if (corePage) {
    const jsonLd = (CORE_PAGE_JSON_LD[pathname] || (() => []))();
    return (
      <Seo
        title={corePage.title}
        description={corePage.description}
        path={corePage.path}
        jsonLd={jsonLd}
      />
    );
  }

  const isNoindex = NOINDEX_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
  if (isNoindex) {
    return <Seo noindex title={SITE_NAME} description="" path={pathname} />;
  }

  return null;
};

export default PageMeta;
